import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import '../StyledComponents/Styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { verifyauthCheck, getUsersList } from "../handlers/adminApi";
import _ from "lodash";
import { DotLoader } from 'react-spinners';  
import axios from 'axios';
import UserDetails from '../AdminDashboardAllCompnent/userlist'; // Import UserDetails component

function UserList() {
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(8);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const hasRun = useRef(false);

    const totalPages = Math.ceil(users.length / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

    const handleStatusChange = async (userId, event) => {
        const newStatus = event.target.value;
        console.log(`handleStatusChange called with userId: ${userId} and newStatus: ${newStatus}`);

        const updatedUsers = users.map((user) =>
            user.user_id === userId ? { ...user, status: newStatus } : user
        );
        setUsers(updatedUsers);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/admin/update-user`, {
                id: userId,
                status: newStatus,
            });

            console.log('API Response:', response);
        } catch (error) {
            console.error('Error updating user status:', error);
            alert('There was an error updating the user status. Please check the console for more details.');
        }
    };

    const handleExportClick = async () => {
        try {
            console.log('Initiating export...');
            const response = await axios.get(`${process.env.REACT_APP_API_HOSTNAME}/admin/export-users`, {
                responseType: 'json',
            });

            console.log('API Response:', response);

            if (response.status === 200 && response.data) {
                const csvString = response.data.data;
                const rows = csvString.split('\n');
                let csvContent = 'Name,Email,Mobile Number,	Status\n';

                rows.slice(1).forEach(row => {
                    const columns = row.split(',');
                    csvContent += `${columns[1]},${columns[2]},${columns[3]},${columns[4]}\n`;
                });

                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'users_list.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                alert('Download successfully');
            } else {
                throw new Error('Failed to export users list: Invalid response');
            }
        } catch (error) {
            console.error('Error exporting users list:', error);
            alert('There was an error exporting the users list. Please check the console for more details.');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const authCheck = async () => {
        var resp = await verifyauthCheck();
        if (resp != null) {
            if (resp.status === true) {
                navigate(location.pathname, {
                    state: { ...location.state, userData: resp.userData }
                });
            } else {
                navigate("/");
            }
        }
    };

    const getUsersRecord = async () => {
        setLoading(true);
        try {
            const response = await getUsersList();
            const fetchedUsers = _.get(response, 'data', []);
            
            const sortedUsers = fetchedUsers.sort((a, b) => b.created_at - a.created_at); 
            
            setUsers(sortedUsers);  
            setLoading(false);
        } catch (error) {
            console.error("Error fetching users:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasRun.current) {
            hasRun.current = true;
            authCheck();
            getUsersRecord();
        }
    }, []);

    const handleUserClick = (user) => {
        setSelectedUser(user);
    };

    return (
        <div className="right" >
            {loading ? (
                <div className="loader-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
                    <DotLoader color="#F7812A" loading={loading} size={60} />
                </div>
            ) : selectedUser ? (
                <UserDetails user={selectedUser} />
            ) : (
                <>
                    <div className="title">
                        <h2>User List</h2>
                    </div>
                    <div className="table">
                        <div className="export-btn-container">
                            <a onClick={handleExportClick} className="export-btn">
                                <FontAwesomeIcon icon={faDownload} />
                                Export users list
                            </a>
                        </div>
                        <table>
                            <tr>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>Mobile Number</th>
                                <th>Status</th>
                            </tr>

                            {currentUsers.map((user) => (
                                <tr key={user.user_id}>
                                    <td>
                                        <span
                                            onClick={() => handleUserClick(user)}  
                                            style={{ color: '#F7812A', cursor: 'pointer' }}
                                        >
                                            {user.name}
                                        </span>
                                    </td>
                                    <td>{user.email}</td>
                                    <td>{user.mobile_number}</td>
                                    <td>
                                        <select
                                            name="status"
                                            id="status"
                                            value={user.status}
                                            onChange={(event) => handleStatusChange(user.user_id, event)}
                                            style={{ width: '160px' }}
                                        >
                                            <option value={user.status}>{user.status}</option>
                                            {user.status === 'active' ? (
                                                <option value="inactive">Inactive</option>
                                            ) : (
                                                <option value="active">Active</option>
                                            )}
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </table>
                        <hr className="horizontal-line" />
                        <div className="pagination">
                            <span>
                                Showing {Math.min(indexOfLastUser, users.length)} of {users.length} entries
                            </span>
                            <div className="pagination-buttons">
                                {[...Array(totalPages)].map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handlePageChange(index + 1)}
                                        className={currentPage === index + 1 ? 'active' : ''}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default UserList;
